import Component from '../component';
import CookiesManager from '../../helpers/cookies-manager';

export default class Intro extends Component {
	constructor(...args) {
		super(...args);

		this._params = {
			delay: 3000,
			animation: 1500
		};

	}

	init() {
		super.init();
		
		// if (!CookiesManager.check('bbi-intro')) {
			// this.dom.component.classList.remove('hide');
			this.animHide();
		// }
	}

	animHide() {
		// CookiesManager.set('bbi-intro', true);
		setTimeout(()=>{
			this.dom.component.classList.add('anim-hide');

			setTimeout(()=>{
				this.dom.component.classList.add('hide');
			}, this._params.animation);
		}, this._params.delay);
	}

	/*
	init() {
	}
	bind() {
	}
	unbind() {
	}
	resize(width, height) {
	}
	*/
}



// WEBPACK FOOTER //
// ./src/js/components/intro/intro.js